import { ShieldCheck, Users, HardHat, Zap } from "lucide-react";
import { COMPANY, TRUST } from "@/data";
import Reveal from "@/components/landing/Reveal";

const ICONS = [ShieldCheck, Users, HardHat, Zap];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-cloud py-24 md:py-32">
    <div className="max-w-[1440px] mx-auto px-5 md:px-12">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="font-display uppercase tracking-[0.2em] text-gold text-sm font-semibold">
              01 — Who We Are
            </span>
            <h2 className="mt-4 font-display font-bold uppercase text-navy text-4xl md:text-5xl leading-[0.95] tracking-tight">
              A local partner you can build a relationship with
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <p className="font-body text-navy/70 text-lg md:text-xl leading-relaxed">
              {COMPANY.name} is a locally owned, family-run remodeling and
              construction company proudly serving {COMPANY.serviceArea}. From a
              single repair to a full renovation, we bring multiple trades under one
              roof — so homeowners and businesses get quality they can count on,
              without the hassle of juggling contractors.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {TRUST.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={item.title} delay={i * 0.08}>
              <div
                className="group bg-white rounded-2xl border border-navy/5 shadow-[0_8px_30px_rgba(15,45,82,0.05)] p-7 h-full hover:-translate-y-1 transition-transform duration-300"
                data-testid={`trust-card-${i}`}
              >
                <div className="w-14 h-14 rounded-full bg-navy flex items-center justify-center mb-5 group-hover:bg-gold transition-colors duration-300">
                  <Icon size={24} className="text-gold group-hover:text-navy-dark transition-colors duration-300" />
                </div>
                <h3 className="font-display font-semibold text-navy text-xl">{item.title}</h3>
                <p className="mt-2 font-body text-navy/60 text-sm">{item.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default About;
